<template>
  <v-row>
    <v-col cols="12" class="pa-0 ma-0" style="position:absolute;top:0;z-index:1">
      <LMap :options="{zoomControl:false}" :center="[47, 2]" :zoom="5" style="height: 100vh">
        <LTileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />

        <LTileLayer
          layer-type="base"
          name="Satellite"
          :key="`sat`"
          :visible="false"
          :opacity=".7"
          :url="
            pathsSat[cursor]
              ? `https://api-my.previmeteo.net/proxy/rv${pathsSat[cursor]}/512/{z}/{x}/{y}/0/1_1.png`
              : ''
          "
        />

        <LTileLayer
          :key="`rad`"
          layer-type="base"
          name="Radar"
          :opacity=".7"
          :url="`https://api-my.previmeteo.net/proxy/rv${paths[cursor]}/512/{z}/{x}/{y}/1/1_1.png`"
        />
        <LControlLayers/>

        <!-- <LControl style="width: 100%" position="topright">
          <v-col
            md="3"
            style="position: absolute; right: 0"
            cols="8"
            offset-md="9"
            offset="4"
            class="text-right"
          >
            <v-btn icon v-if="!deployed" @click="deployed = !deployed"
              ><v-icon>mdi-cog</v-icon></v-btn
            >
            <v-card v-if="deployed">
              <v-card-title class="pb-0 mb-0">
                <v-spacer />
                <v-btn small icon v-if="deployed" @click="deployed = !deployed"
                  ><v-icon>mdi-minus</v-icon></v-btn
                >
              </v-card-title>
              <v-card-text class="pa-2">
                <v-slider
                  label="Opacité radar"
                  :min="0"
                  :step="0.1"
                  dense
                  :max="1"
                  v-model="opacityRad"
                />
                <v-slider
                  :min="0"
                  label="Opacité satellite"
                  :step="0.1"
                  dense
                  :max="1"
                  v-model="opacitySat"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </LControl> -->
      </LMap>
    </v-col>
    <v-col class="slider-timeline pa-0" cols=12 style="position:absolute;bottom:1em;height: 30px;">
      <v-col style="position:absolute;bottom:4em;">
            <div id="DIV_1">
              <v-btn icon @click="legend = !legend">
                <v-icon v-if="!legend">mdi-eye</v-icon>
                <v-icon v-else>mdi-close</v-icon>
              </v-btn>
              <ul id="UL_3" v-if="legend">
                <li id="LI_4">
                  <p id="P_5">{{$t('rv_pluie')}}</p>
                  <div id="DIV_6"></div>
                  <ul id="UL_7">
                    <li id="LI_8">
                      <div id="DIV_9"></div>
                      <p id="P_10">{{$t('rv_couvert')}}</p>
                    </li>
                    <li id="LI_11">
                      <div id="DIV_12"></div>
                      <p id="P_13">{{$t('rv_bruine')}}</p>
                    </li>
                    <li id="LI_14">
                      <div id="DIV_15"></div>
                      <p id="P_16">{{$t('rv_pluie_faible')}}</p>
                    </li>
                    <li id="LI_17">
                      <div id="DIV_18"></div>
                      <p id="P_19">{{$t('rv_pluie_modere')}}</p>
                    </li>
                    <li id="LI_20">
                      <div id="DIV_21"></div>
                      <p id="P_22">{{$t('rv_pluie_forte')}}</p>
                    </li>
                    <li id="LI_23">
                      <div id="DIV_24"></div>
                      <p id="P_25">{{$t('rv_grele')}}</p>
                    </li>
                  </ul>
                </li>
                <li id="LI_26">
                  <p id="P_27">{{$t('rv_neige')}}</p>
                  <div id="DIV_28"></div>
                  <ul id="UL_29">
                    <li id="LI_30">
                      <div id="DIV_31"></div>
                      <p id="P_32">{{$t('rv_neige_faible')}}</p>
                    </li>
                    <li id="LI_33">
                      <div id="DIV_34"></div>
                      <p id="P_35">{{$t('rv_neige_modere')}}</p>
                    </li>
                    <li id="LI_36">
                      <div id="DIV_37"></div>
                      <p id="P_38">{{$t('rv_neige_forte')}}</p>
                    </li>
                  </ul>
                </li>
              </ul>
              <button id="BUTTON_39">
                <img
                  src="https://www.rainviewer.com/images/icons/info-icon.svg"
                  width="18"
                  height="18"
                  alt="info"
                  id="IMG_40"
                />
              </button>
            </div>
          </v-col>
      <v-slider v-model="selectedTS" ticks="always" v-if="times.length" :step="getTimesSteps" thumb-label="always"
            :min="times[0]" :max="times[times.length - 1]">
            <template v-slot:thumb-label="{ value }">
              {{ moment(value).format('DD/MM HH:mm') }}
            </template>
          </v-slider>
    </v-col>
  </v-row>
</template>

<script>
import { LMap, LTileLayer, LControl, LControlLayers } from "vue2-leaflet";
import api from "@/api";
import moment from "moment";
import VueHorizontalTimelineSlider from "../VueHorizontalTimelineSlider.vue";
export default {
  data: () => ({
    paths: [],
    times: [],
    opacityRad: 0.7,
    opacitySat: 0,
    pathsSat: [],
    legend: false,
    deployed: false,
    cursor: 0,
    selectedTS: null,
    moment: moment,
  }),
  components: {
    LMap,
    LTileLayer,
    LControl,
    VueHorizontalTimelineSlider,
    LControlLayers,
  },
  computed: {
    getTimesSteps() {
      if (!this.times.length) return;
      let steps = this.times[1] - this.times[0];
      return steps;
    },
    rvUrl() {
      if (!this.paths[this.cursor]) return false;
      return `https://api-my.previmeteo.net${
        this.paths[this.cursor]
      }/512/{z}/{x}/{y}/1/1_1.png`;
    },
    rvUrlSat() {
      if (!this.pathsSat[this.cursor]) return false;
      return `https://api-my.previmeteo.net${
        this.pathsSat[this.cursor]
      }/512/{z}/{x}/{y}/0/1_1.png`;
    },
  },
  methods: {
    async getRainViewerLayers() {
      const data = await api.weather.get();
      data.radar.past.forEach((pastData) => {
        this.paths.push(pastData.path);
        this.times.push(pastData.time * 1000);
      });
      data.radar.nowcast.forEach((nowCastData) => {
        this.paths.push(nowCastData.path);
        this.times.push(nowCastData.time * 1000);
      });
      data.satellite.infrared.forEach((element) => {
        this.pathsSat.push(element.path);
      });
      this.cursor = this.paths.length - 4;
    },
  },
  mounted() {
    this.getRainViewerLayers();
  },
  watch: {
    selectedTS() {
      this.cursor = this.times.findIndex((map) => map == this.selectedTS);
    },
  },
};
</script>

<style>
.leaflet-top.leaflet-right {
  width: 100%;
}

#DIV_1 {
  /* block-size: 204px; */
  border-end-end-radius: 20px;
  border-end-start-radius: 20px;
  border-start-end-radius: 20px;
  border-start-start-radius: 20px;
  bottom: 20px;
  box-shadow: rgba(7, 47, 75, 0.3) 0px 2px 10px 0px;
  /* height: 204px; */
  left: 20px;
  padding-block-end: 16px;
  padding-block-start: 16px;
  padding-inline-end: 16px;
  padding-inline-start: 16px;
  perspective-origin: 149.531px 118px;
  position: absolute;
  /* right: 171.938px; */
  text-align: left;
  /* top: 244px;
    transform-origin: 149.531px 118px; */
  /* width: 267.062px; */
  z-index: 999;
  background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 20px;
  font: 16px / 16px Inter, sans-serif;
  padding: 5px;
} /*#DIV_1*/

#DIV_1:after {
  text-align: left;
  font: 16px / 16px Inter, sans-serif;
} /*#DIV_1:after*/

#DIV_1:before {
  text-align: left;
  font: 16px / 16px Inter, sans-serif;
} /*#DIV_1:before*/

#BUTTON_2 {
  background-position: 0px 50%;
  block-size: 20px;
  border-block-end-color: rgb(0, 0, 0);
  border-block-end-style: none;
  border-block-end-width: 0px;
  border-block-start-color: rgb(0, 0, 0);
  border-block-start-style: none;
  border-block-start-width: 0px;
  border-inline-end-color: rgb(0, 0, 0);
  border-inline-end-style: none;
  border-inline-end-width: 0px;
  border-inline-start-color: rgb(0, 0, 0);
  border-inline-start-style: none;
  border-inline-start-width: 0px;
  bottom: 200px;
  cursor: pointer;
  display: block;
  height: 20px;
  inline-size: 20px;
  inset-block-end: 200px;
  inset-block-start: 16px;
  inset-inline-end: 20px;
  inset-inline-start: 259.062px;
  left: 259.062px;
  perspective-origin: 10px 10px;
  position: absolute;
  right: 20px;
  top: 16px;
  transform-origin: 10px 10px;
  width: 20px;
  background: rgba(0, 0, 0, 0)
    url("https://www.rainviewer.com/images/rainviewer2/map/rw-icon-close.svg")
    no-repeat scroll 0px 50% / 13px 13px padding-box border-box;
  border: 0px none rgb(0, 0, 0);
  font: 16px Arial;
} /*#BUTTON_2*/

#BUTTON_2:after {
  cursor: pointer;
  font: 16px Arial;
} /*#BUTTON_2:after*/

#BUTTON_2:before {
  cursor: pointer;
  font: 16px Arial;
} /*#BUTTON_2:before*/

#UL_3 {
  block-size: 204px;
  display: flex;
  height: 204px;
  inline-size: 267.062px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  padding-inline-start: 0px;
  perspective-origin: 133.531px 102px;
  text-align: left;
  transform-origin: 133.531px 102px;
  width: 267.062px;
  font: 16px / 16px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  padding: 0px;
} /*#UL_3*/

#UL_3:after {
  display: block;
  text-align: left;
  font: 16px / 16px Inter, sans-serif;
  list-style: outside none none;
} /*#UL_3:after*/

#UL_3:before {
  display: block;
  text-align: left;
  font: 16px / 16px Inter, sans-serif;
  list-style: outside none none;
} /*#UL_3:before*/

#LI_4 {
  block-size: 204px;
  height: 204px;
  inline-size: 123.5px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 61.75px 102px;
  transform-origin: 61.75px 102px;
  width: 123.5px;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_4*/

#LI_4:after {
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_4:after*/

#LI_4:before {
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_4:before*/

#P_5 {
  block-size: 18px;
  border-block-end-color: rgb(119, 121, 144);
  border-block-start-color: rgb(119, 121, 144);
  border-inline-end-color: rgb(119, 121, 144);
  border-inline-start-color: rgb(119, 121, 144);
  caret-color: rgb(119, 121, 144);
  color: rgb(119, 121, 144);
  column-rule-color: rgb(119, 121, 144);
  height: 18px;
  inline-size: 123.5px;
  letter-spacing: 0.1px;
  margin-block-end: 16px;
  margin-block-start: 0px;
  perspective-origin: 61.75px 9px;
  text-align: left;
  text-decoration: none solid rgb(119, 121, 144);
  text-transform: uppercase;
  transform-origin: 61.75px 9px;
  width: 123.5px;
  border: 0px none rgb(119, 121, 144);
  font: 600 15px / 18px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 0px 16px;
  outline: rgb(119, 121, 144) none 0px;
} /*#P_5*/

#P_5:after {
  border-block-end-color: rgb(119, 121, 144);
  border-block-start-color: rgb(119, 121, 144);
  border-inline-end-color: rgb(119, 121, 144);
  border-inline-start-color: rgb(119, 121, 144);
  caret-color: rgb(119, 121, 144);
  color: rgb(119, 121, 144);
  column-rule-color: rgb(119, 121, 144);
  letter-spacing: 0.1px;
  text-align: left;
  text-decoration: none solid rgb(119, 121, 144);
  text-transform: uppercase;
  border: 0px none rgb(119, 121, 144);
  font: 600 15px / 18px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(119, 121, 144) none 0px;
} /*#P_5:after*/

#P_5:before {
  border-block-end-color: rgb(119, 121, 144);
  border-block-start-color: rgb(119, 121, 144);
  border-inline-end-color: rgb(119, 121, 144);
  border-inline-start-color: rgb(119, 121, 144);
  caret-color: rgb(119, 121, 144);
  color: rgb(119, 121, 144);
  column-rule-color: rgb(119, 121, 144);
  letter-spacing: 0.1px;
  text-align: left;
  text-decoration: none solid rgb(119, 121, 144);
  text-transform: uppercase;
  border: 0px none rgb(119, 121, 144);
  font: 600 15px / 18px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(119, 121, 144) none 0px;
} /*#P_5:before*/

#DIV_6 {
  block-size: 170px;
  border-end-end-radius: 12px;
  border-end-start-radius: 12px;
  border-start-end-radius: 12px;
  border-start-start-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  float: left;
  height: 170px;
  inline-size: 14px;
  margin-inline-end: 12px;
  perspective-origin: 7px 85px;
  text-align: left;
  transform-origin: 7px 85px;
  width: 14px;
  background: rgba(0, 0, 0, 0)
    linear-gradient(
      rgb(223, 223, 223),
      rgb(223, 223, 223),
      rgb(155, 234, 143),
      rgb(88, 255, 66),
      rgb(71, 194, 120),
      rgb(71, 147, 249),
      rgb(12, 89, 255),
      rgb(97, 83, 193),
      rgb(255, 147, 163),
      rgb(255, 63, 53),
      rgb(194, 5, 17),
      rgb(255, 235, 10)
    )
    repeat scroll 0% 0% / auto padding-box border-box;
  border-radius: 12px;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 12px 0px 0px;
} /*#DIV_6*/

#DIV_6:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_6:after*/

#DIV_6:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_6:before*/

#UL_7 {
  block-size: 163.188px;
  display: flex;
  height: 163.188px;
  inline-size: 97.5px;
  justify-content: space-between;
  margin-block-end: 0px;
  margin-block-start: 0px;
  padding-inline-start: 0px;
  perspective-origin: 48.75px 81.5938px;
  text-align: left;
  transform-origin: 48.75px 81.5938px;
  width: 97.5px;
  flex-flow: column nowrap;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  padding: 0px;
} /*#UL_7*/

#UL_7:after {
  display: block;
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#UL_7:after*/

#UL_7:before {
  display: block;
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#UL_7:before*/

#LI_8,
#LI_11,
#LI_14,
#LI_17,
#LI_20,
#LI_23 {
  align-items: center;
  block-size: 20px;
  display: flex;
  height: 20px;
  inline-size: 97.5px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 48.75px 10px;
  transform-origin: 48.75px 10px;
  width: 97.5px;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_8, #LI_11, #LI_14, #LI_17, #LI_20, #LI_23*/

#LI_8:after,
#LI_11:after,
#LI_14:after,
#LI_17:after,
#LI_20:after,
#LI_23:after {
  display: block;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_8:after, #LI_11:after, #LI_14:after, #LI_17:after, #LI_20:after, #LI_23:after*/

#LI_8:before,
#LI_11:before,
#LI_14:before,
#LI_17:before,
#LI_20:before,
#LI_23:before {
  display: block;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_8:before, #LI_11:before, #LI_14:before, #LI_17:before, #LI_20:before, #LI_23:before*/

#DIV_9 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(223, 223, 223) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_9*/

#DIV_9:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_9:after*/

#DIV_9:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_9:before*/

#P_10 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 50.1562px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 25.0781px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 25.0781px 10px;
  white-space: nowrap;
  width: 50.1562px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_10*/

#P_10:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_10:after*/

#P_10:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_10:before*/

#DIV_12 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(155, 234, 143) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_12*/

#DIV_12:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_12:after*/

#DIV_12:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_12:before*/

#P_13 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 38.1406px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 19.0625px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 19.0703px 10px;
  white-space: nowrap;
  width: 38.1406px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_13*/

#P_13:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_13:after*/

#P_13:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_13:before*/

#DIV_15 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(71, 194, 120) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_15*/

#DIV_15:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_15:after*/

#DIV_15:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_15:before*/

#P_16 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 51.5781px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 25.7812px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 25.7891px 10px;
  white-space: nowrap;
  width: 51.5781px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_16*/

#P_16:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_16:after*/

#P_16:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_16:before*/

#DIV_18 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(12, 89, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_18*/

#DIV_18:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_18:after*/

#DIV_18:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_18:before*/

#P_19 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 77.5px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 38.75px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 38.75px 10px;
  white-space: nowrap;
  width: 77.5px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_19*/

#P_19:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_19:after*/

#P_19:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_19:before*/

#DIV_21 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(255, 147, 163) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_21*/

#DIV_21:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_21:after*/

#DIV_21:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_21:before*/

#P_22 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 42.1406px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 21.0625px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 21.0703px 10px;
  white-space: nowrap;
  width: 42.1406px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_22*/

#P_22:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_22:after*/

#P_22:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_22:before*/

#DIV_24 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(194, 5, 17) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_24*/

#DIV_24:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_24:after*/

#DIV_24:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_24:before*/

#P_25 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 20.9219px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 10.4531px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 10.4609px 10px;
  white-space: nowrap;
  width: 20.9219px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_25*/

#P_25:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_25:after*/

#P_25:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_25:before*/

#LI_26 {
  block-size: 204px;
  height: 204px;
  inline-size: 123.562px;
  margin-inline-start: 20px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 61.7812px 102px;
  transform-origin: 61.7812px 102px;
  width: 123.562px;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 0px 0px 20px;
} /*#LI_26*/

#LI_26:after {
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_26:after*/

#LI_26:before {
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_26:before*/

#P_27 {
  block-size: 18px;
  border-block-end-color: rgb(119, 121, 144);
  border-block-start-color: rgb(119, 121, 144);
  border-inline-end-color: rgb(119, 121, 144);
  border-inline-start-color: rgb(119, 121, 144);
  caret-color: rgb(119, 121, 144);
  color: rgb(119, 121, 144);
  column-rule-color: rgb(119, 121, 144);
  height: 18px;
  inline-size: 123.562px;
  letter-spacing: 0.1px;
  margin-block-end: 16px;
  margin-block-start: 0px;
  perspective-origin: 61.7812px 9px;
  text-align: left;
  text-decoration: none solid rgb(119, 121, 144);
  text-transform: uppercase;
  transform-origin: 61.7812px 9px;
  width: 123.562px;
  border: 0px none rgb(119, 121, 144);
  font: 600 15px / 18px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 0px 16px;
  outline: rgb(119, 121, 144) none 0px;
} /*#P_27*/

#P_27:after {
  border-block-end-color: rgb(119, 121, 144);
  border-block-start-color: rgb(119, 121, 144);
  border-inline-end-color: rgb(119, 121, 144);
  border-inline-start-color: rgb(119, 121, 144);
  caret-color: rgb(119, 121, 144);
  color: rgb(119, 121, 144);
  column-rule-color: rgb(119, 121, 144);
  letter-spacing: 0.1px;
  text-align: left;
  text-decoration: none solid rgb(119, 121, 144);
  text-transform: uppercase;
  border: 0px none rgb(119, 121, 144);
  font: 600 15px / 18px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(119, 121, 144) none 0px;
} /*#P_27:after*/

#P_27:before {
  border-block-end-color: rgb(119, 121, 144);
  border-block-start-color: rgb(119, 121, 144);
  border-inline-end-color: rgb(119, 121, 144);
  border-inline-start-color: rgb(119, 121, 144);
  caret-color: rgb(119, 121, 144);
  color: rgb(119, 121, 144);
  column-rule-color: rgb(119, 121, 144);
  letter-spacing: 0.1px;
  text-align: left;
  text-decoration: none solid rgb(119, 121, 144);
  text-transform: uppercase;
  border: 0px none rgb(119, 121, 144);
  font: 600 15px / 18px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(119, 121, 144) none 0px;
} /*#P_27:before*/

#DIV_28 {
  block-size: 170px;
  border-end-end-radius: 12px;
  border-end-start-radius: 12px;
  border-start-end-radius: 12px;
  border-start-start-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  float: left;
  height: 170px;
  inline-size: 14px;
  margin-inline-end: 12px;
  perspective-origin: 7px 85px;
  text-align: left;
  transform-origin: 7px 85px;
  width: 14px;
  background: rgba(0, 0, 0, 0)
    linear-gradient(rgb(159, 255, 255), rgb(95, 207, 255), rgb(0, 95, 255))
    repeat scroll 0% 0% / auto padding-box border-box;
  border-radius: 12px;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 12px 0px 0px;
} /*#DIV_28*/

#DIV_28:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_28:after*/

#DIV_28:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_28:before*/

#UL_29 {
  block-size: 163.188px;
  display: flex;
  height: 163.188px;
  /* inline-size: 97.5625px; */
  justify-content: space-between;
  margin-block-end: 0px;
  margin-block-start: 0px;
  padding-inline-start: 0px;
  perspective-origin: 48.7812px 81.5938px;
  text-align: left;
  transform-origin: 48.7812px 81.5938px;
  /* width: 97.5625px; */
  flex-flow: column nowrap;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  padding: 0px;
} /*#UL_29*/

#UL_29:after {
  display: block;
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#UL_29:after*/

#UL_29:before {
  display: block;
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#UL_29:before*/

#LI_30,
#LI_33,
#LI_36 {
  align-items: center;
  block-size: 20px;
  display: flex;
  height: 20px;
  inline-size: 97.5625px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 48.7812px 10px;
  transform-origin: 48.7812px 10px;
  width: 97.5625px;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_30, #LI_33, #LI_36*/

#LI_30:after,
#LI_33:after,
#LI_36:after {
  display: block;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_30:after, #LI_33:after, #LI_36:after*/

#LI_30:before,
#LI_33:before,
#LI_36:before {
  display: block;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#LI_30:before, #LI_33:before, #LI_36:before*/

#DIV_31 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(143, 255, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_31*/

#DIV_31:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_31:after*/

#DIV_31:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_31:before*/

#P_32 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 60.5625px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 30.2812px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 30.2812px 10px;
  white-space: nowrap;
  width: 60.5625px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_32*/

#P_32:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_32:after*/

#P_32:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_32:before*/

#DIV_34 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(95, 207, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_34*/

#DIV_34:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_34:after*/

#DIV_34:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_34:before*/

#P_35 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 77.5625px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 38.7812px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 38.7812px 10px;
  white-space: nowrap;
  width: 77.5625px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_35*/

#P_35:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_35:after*/

#P_35:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_35:before*/

#DIV_37 {
  block-size: 12px;
  border-end-end-radius: 50%;
  border-end-start-radius: 50%;
  border-start-end-radius: 50%;
  border-start-start-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px inset;
  height: 12px;
  inline-size: 12px;
  margin-inline-end: 8px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 6px 6px;
  text-align: left;
  transform-origin: 6px 6px;
  width: 12px;
  background: rgb(15, 111, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 50%;
  flex: 0 0 auto;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px 8px 0px 0px;
} /*#DIV_37*/

#DIV_37:after {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_37:after*/

#DIV_37:before {
  text-align: left;
  font: 500 16px / 26px Inter, sans-serif;
  list-style: outside none none;
} /*#DIV_37:before*/

#P_38 {
  block-size: 20px;
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  height: 20px;
  inline-size: 67.8438px;
  letter-spacing: -0.2px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  min-block-size: auto;
  min-height: auto;
  min-inline-size: auto;
  min-width: auto;
  perspective-origin: 33.9219px 10px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  transform-origin: 33.9219px 10px;
  white-space: nowrap;
  width: 67.8438px;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  margin: 0px;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_38*/

#P_38:after {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_38:after*/

#P_38:before {
  border-block-end-color: rgb(126, 145, 173);
  border-block-start-color: rgb(126, 145, 173);
  border-inline-end-color: rgb(126, 145, 173);
  border-inline-start-color: rgb(126, 145, 173);
  caret-color: rgb(126, 145, 173);
  color: rgb(126, 145, 173);
  column-rule-color: rgb(126, 145, 173);
  letter-spacing: -0.2px;
  text-align: left;
  text-decoration: none solid rgb(126, 145, 173);
  white-space: nowrap;
  border: 0px none rgb(126, 145, 173);
  font: 500 12px / 20px Inter, sans-serif;
  list-style: outside none none;
  outline: rgb(126, 145, 173) none 0px;
} /*#P_38:before*/

#BUTTON_39 {
  background-position: 0px 50%;
  border-block-end-color: rgb(0, 0, 0);
  border-block-end-style: none;
  border-block-end-width: 0px;
  border-block-start-color: rgb(0, 0, 0);
  border-block-start-style: none;
  border-block-start-width: 0px;
  border-inline-end-color: rgb(0, 0, 0);
  border-inline-end-style: none;
  border-inline-end-width: 0px;
  border-inline-start-color: rgb(0, 0, 0);
  border-inline-start-style: none;
  border-inline-start-width: 0px;
  cursor: pointer;
  display: none;
  justify-content: center;
  margin-block-start: 14px;
  margin-inline-end: auto;
  margin-inline-start: auto;
  background: rgba(0, 0, 0, 0) none repeat scroll 0px 50% / auto padding-box
    border-box;
  border: 0px none rgb(0, 0, 0);
  font: 16px Arial;
  margin: 14px auto 0px;
} /*#BUTTON_39*/

#BUTTON_39:after {
  cursor: pointer;
  font: 16px Arial;
} /*#BUTTON_39:after*/

#BUTTON_39:before {
  cursor: pointer;
  font: 16px Arial;
} /*#BUTTON_39:before*/

#IMG_40 {
  block-size: 18px;
  cursor: pointer;
  height: 18px;
  inline-size: 18px;
  text-align: left;
  width: 18px;
  font: 16px Arial;
} /*#IMG_40*/

#IMG_40:after {
  cursor: pointer;
  text-align: left;
  font: 16px Arial;
} /*#IMG_40:after*/

#IMG_40:before {
  cursor: pointer;
  text-align: left;
  font: 16px Arial;
} /*#IMG_40:before*/

.leaflet-control-layers.leaflet-control {
    top: 4em;
}

.slider-timeline {
    z-index: 2;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #7c7c7c;
    box-shadow: 1px 1px 5px #58585847;
    background-color: #0d070378 !important;

  }
</style>
